import {CSSProperties, FC} from 'react';


export interface IIconCarSeatRightProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconCarSeatRight: FC<IIconCarSeatRightProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlSpace="preserve"
            x="0"
            y="0"
            aria-hidden="true"
            viewBox="0 0 200 200"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <defs>
                <linearGradient x1="50%" x2="50%" y1="100%" y2="0%" className="cerosgradient" data-cerosgradient="true" gradientUnits="userSpaceOnUse">
                    <stop offset="0%" stopColor="#d1d1d1" />
                    <stop offset="100%" stopColor="#d1d1d1" />
                </linearGradient>
            </defs>
            <path d="M156.78 152.88c-3.84-14.44-21.79-14.82-31.44-15.02-8.01-.17-16.54.2-25.35 1.11-5.43.56-12.41 1.52-19.2 3.96.24-.43.46-.84.68-1.24 5.1-9.47 5.35-20.95 5.1-28.76-.35-10.71-2.52-21.27-6.42-31.4a97.131 97.131 0 0 0-7.01-14.48 96.185 96.185 0 0 0-4.39-6.74c-.14-.2-.59-.75-1.27-1.56-1.41-1.7-2.38-2.9-2.89-3.58 3.14-5.64 6.96-12.6 8.1-20.27 1.03-6.89-.33-16.18-7.27-21.59-2.87-2.23-6.18-3.32-9.34-3.06-8.01.68-12.12 9.31-13.51 12.99-3.71 9.81-4.29 20.52-4.37 28.76-.13 12.49.87 24.7 1.76 33.93.49 5.09 1.06 10.26 1.56 14.82l.02.16c.78 7.11 1.59 14.47 2.17 21.71.36 4.54.66 9.17.96 13.64l.02.3c.5 7.72 1.02 15.7 1.86 23.55.11 1.03.2 2.08.3 3.15.4 4.39.81 8.93 2.32 13.08 2.4 6.6 7.46 7.8 12.08 8.1 3.7.25 7.41-.03 10.99-.3l.2-.01c2.25-.17 4.58-.35 6.85-.39 3.19-.06 6.43-.2 9.57-.33 3.04-.13 5.79-.25 8.56-.31 14.41-.33 26.2.12 37.09 1.42 1.86.22 3.66.04 5.06.04 3.31 0 5.84-.32 8.56-1.63 3.53-1.7 6.84-3.72 8.41-9.8 1.76-6.8 1.85-14.18.24-20.25zm-40.06-5.21 2.25.04c6.07.1 12.96.22 18.71 1.26 2.29.41 4.89.98 6.78 2.46 1.7 1.33 2.94 3.53 3.49 6.19.53 2.57.42 5.31.25 7.9-.16 2.43-.42 4.95-1.73 6.72-1.09 1.47-2.99 2.51-5.34 2.91-2.18.37-4.51.19-6.76.02l-.25-.02a383.517 383.517 0 0 0-66.32.82c-.56.06-1.14.13-1.73.2-2.33.3-4.74.61-6.75-.17-2.4-.92-3.07-4.14-3.67-6.98l-.1-.46 2.05-1.43c9.27-6.47 18.02-12.59 29.13-16.04 8.37-2.59 17.89-3.67 29.99-3.42zM50.57 26.75c1.4-3.04 4.04-6.12 6.77-6.12.35 0 .69.05 1.03.15 1.9.57 3.11 2.65 3.78 4.3C65.11 32.3 63.52 41.61 58 49.4l-.3.42c-1.05 1.47-2.24 3.13-2.43 5.21-.29 3.23 1.83 5.72 3.7 7.93.8.94 1.59 1.92 2.34 2.89C68.8 75.56 74.1 87.1 76.63 99.22c3.12 14.92 4.05 35.32-9.25 47.81-4.36 4.1-7.96 7.2-13.02 10.5-.07-2.14-.08-4.29-.1-6.23-.01-1.93-.03-3.93-.08-5.89-.44-14.59-2.24-29.31-3.99-43.59-1.88-15.33-3.82-31.19-4.04-46.84-.12-8.93.31-19.27 4.42-28.23z" />
        </svg>
    );
};
